const CompetitiveAdvantage = () => {
  return (
    <>
      <div className="container ">
        {/* /features */}
        <div
          className=" classic-features  rounded bg-white shadow-sm px-30 px-sm-40 px-md-50 px-xl-100 pt-30"
          style={{ marginTop: 19, marginBottom: 19 }}
        >
          <div className="row">
            <div className="col-lg-3">
              <div className="classic-features-item d-flex align-items-center mb-30">
                <img
                  src="/themes/custom-1a98/userfiles/477d9f.jpg?"
                  alt="مشاوره تخصصی"
                  className="classic-features-item-image"
                />
                {/*m=thumb&h=40&q=high*/}
                <div className="mr-10">
                  <h3 className="classic-features-item-title d-block m-0">
                    مشاوره تخصصی
                  </h3>
                  <p className="classic-features-item-description d-block m-0">
                    قبل و بعد از خرید
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="classic-features-item d-flex align-items-center mb-30">
                <img
                  src="/themes/custom-1a98/userfiles/e57f55.jpg?"
                  alt="ارسال رایگان"
                  className="classic-features-item-image"
                />
                {/*m=thumb&h=40&q=high*/}
                <div className="mr-10">
                  <h3 className="classic-features-item-title d-block m-0">
                    ارسال رایگان
                  </h3>
                  <p className="classic-features-item-description d-block m-0">
                    خریدهای بالای ۱ میلیون
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="classic-features-item d-flex align-items-center mb-30">
                <img
                  src="/themes/custom-1a98/userfiles/9f8e03.jpg?"
                  alt="گارانتی معتبر"
                  className="classic-features-item-image"
                />
                {/*m=thumb&h=40&q=high*/}
                <div className="mr-10">
                  <h3 className="classic-features-item-title d-block m-0">
                    گارانتی معتبر
                  </h3>
                  <p className="classic-features-item-description d-block m-0">
                    ۷ روز مهلت تست سلامت
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="classic-features-item d-flex align-items-center mb-30">
                <img
                  src="/themes/custom-1a98/userfiles/6e59db.jpg?"
                  alt="تحویل اکسپرس"
                  className="classic-features-item-image"
                />
                {/*m=thumb&h=40&q=high*/}
                <div className="mr-10">
                  <h3 className="classic-features-item-title d-block m-0">
                    تحویل اکسپرس
                  </h3>
                  <p className="classic-features-item-description d-block m-0">
                    در کوتاه ترین زمان
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompetitiveAdvantage;
